import {get as _get, isEmpty as _isEmpty} from 'lodash';
import {Button} from 'semantic-ui-react';
import React from 'react';

import DefaultForm from '@appComponents/DefaultForm';
import {WIZARD_TABS_VALIDATION_TEXT} from '@constants/messages';

import {getDataFromAllSteps, showErrorNotice} from '../../utils/eventGeoRestriction';

export class EventGeoRestrictionsFormBlackoutZonesForm extends DefaultForm {
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        const {GraphQLEntityData, GraphQLOptionsData, stepsMethods} = this.props;
        const assignedBlackoutZonesData = _get(GraphQLEntityData, 'eventGeoRestriction.blackout_zones', []);
        const blackoutZones = _get(GraphQLOptionsData, 'blackoutZones', []);
        const isLoading = GraphQLEntityData?.loading || GraphQLOptionsData?.loading;

        if (!isLoading && !this.state.dataLoaded) {
            const assignedBlackoutZonesIds = assignedBlackoutZonesData.map(zone => zone.id);
            const blackoutZonesOptions = blackoutZones.filter(zone =>
                zone.is_archived ? assignedBlackoutZonesIds.includes(zone.id) : !zone.is_archived
            );

            this.setField('blackoutZones', {
                defaultValue: assignedBlackoutZonesData.map(zone => zone.id),
                options: blackoutZonesOptions,
            });

            this.setState({dataLoaded: true});
        }

        if (!_isEmpty(stepsMethods)) {
            stepsMethods.setForm('step3', this.props);
        }
    }

    prepareDataForSubmit = () => {
        const data = getDataFromAllSteps(
            this.props.stepsMethods,
            this.props.formParams.optionsVariables.event
        );
        const isFormDataValid = null !== data.territory_selection_type || 0 < data.blackout_zones.length;

        return isFormDataValid ? data : showErrorNotice();
    };

    onFormSubmit = (data) => {
        if (!_isEmpty(this.props.stepsMethods) && !this.props.stepsMethods.validateForms()) {
            this.setFormMessage(WIZARD_TABS_VALIDATION_TEXT(
                _get(this.props, 'Model.label', _get(this.props, 'Model.formName', '')).toLowerCase()
            ));
        } else {
            return super.onFormSubmit(data);
        }
    };

    renderAdditionalButtons = () => {
        return !this.props.Model.editForm && (
            <Button
                color='grey'
                content='Back'
                icon='angle double left'
                labelPosition='left'
                onClick={this.props.stepsMethods.showPreviousStep}
            />
        );
    };
}

export default EventGeoRestrictionsFormBlackoutZonesForm;
